module.exports = __webpack_public_path__ + "static/media/icon-empty.7df4ac01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/common/icon/icon-empty.svg
// module id = 1162
// module chunks = 0